






























































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import UserValidator from "@/resources/mixins/userValidator";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";

@Component({
  name: "space-settings-component",
})
export default class SpaceSettingsComponent extends mixins(
  NotificationEvent,
  UserValidator,
  Plans
) {
  @Prop({ default: false }) isFromCampus;
  @Prop({ default: () => {} }) goBack;
  confirmDelete = false;
  confirmDisabled = false;
  speedNetworkingCycleTime = 5;
  isChatActive = false;
  isWebinarChatActive = false;
  isMuteAndCameraActive = false;
  isPlaylistActivated = false;
  loading = false;
  loadingDelete = false;
  loadingEnabled = false;
  isGameKiller = false;
  eliminationsToWin = 5;
  PLAN = PLAN;
  mounted() {
    this.speedNetworkingCycleTime =
      this.selectedSpaceCustomize.speedNetworkingCycleTime;
    this.isChatActive = this.selectedSpaceCustomize.isChatActive;
    this.isWebinarChatActive = this.selectedSpaceCustomize.isWebinarChatActive;
    this.isMuteAndCameraActive =
      this.selectedSpaceCustomize.canUsersMuteMicrophoneOrTurnOffCamera;
    this.isPlaylistActivated = this.selectedSpaceCustomize.isPlaylistActivated;
  }
  /*get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }*/
  get selectedSpaceCustomize() {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    return space;
  }
  get spaceAvailable(): any {
    return this.$store.getters["SpaceStore/getSpacesAvailable"];
  }
  changeInputNumber(e) {
    if (parseInt(e.target.value + e.key) > 60)
      this.speedNetworkingCycleTime = 1;
    if (parseInt(e.target.value + e.key) < 1) this.speedNetworkingCycleTime = 1;
  }
  async onSave(): Promise<void> {
    this.loading = true;
    if (this.speedNetworkingCycleTime) {
      await this.$store.dispatch("SpaceStore/updateSpaceAction", {
        spaceId: this.selectedSpaceCustomize.id,
        payload: {
          speedNetworkingCycleTime: parseInt(
            this.speedNetworkingCycleTime.toString()
          ),
          isChatActive: this.isChatActive,
          isWebinarChatActive: this.isWebinarChatActive,
          canUsersMuteMicrophoneOrTurnOffCamera: this.isMuteAndCameraActive,
          isPlaylistActivated: this.activeOptionPlan(PLAN.SPOTIFY_LIST) ? this.isPlaylistActivated : false,
        },
        callback: () => {
          this.loading = false;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.spaceUpdate")
          );
        },
      });
    }
  }
  releasePins() {
    if (!this.activeOptionPlan(PLAN.LOCK_ROOM)) return;
    this.$store.dispatch("SpaceStore/removeAllPinSpaceAction", {
      spaceId: this.selectedSpaceCustomize.id,
      callback: () => {
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("roomPin.doneReleasePin")
        );
      },
    });
  }
  deleteSpace(): void {
    if (this.spaceAvailable.length <= 1) return;
    this.loadingDelete = true;
    this.$store.dispatch("SpaceStore/deleteSpaceAction", {
      spaceId: this.selectedSpaceCustomize.id,
      callback: () => {
        this.loadingDelete = false;
        this.confirmDelete = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.deleteSpace")
        );
        if (this.isFromCampus) {
          this.goBack();
        }
      },
    });
  }
  enableOrDisabledSpace(): void {
    this.loadingEnabled = true;
    const selectedSpaceCustomize = this.selectedSpaceCustomize;
    if (this.isSuperAdmin())
      this.$store.dispatch(
        "SpaceStore/enableOrDisabledSpaceBySuperAdminAction",
        {
          spaceId: selectedSpaceCustomize.id,
          payload: {
            enabledBySuperAdmin: !selectedSpaceCustomize.enabledBySuperAdmin,
          },
          callback: (space) => {
            this.loadingEnabled = false;
            this.confirmDisabled = false;
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.spaceUpdate")
            );
            if (space.id == selectedSpaceCustomize.id) {
              this.$store.dispatch("SpaceStore/setSpaceAction", space);
              this.$store.dispatch(
                "SpaceStore/setSelectedSpaceCustomizeAction",
                space
              );
            } else {
              this.$store.dispatch(
                "SpaceStore/setSelectedSpaceCustomizeAction",
                space
              );
            }
          },
        }
      );
    else
      this.$store.dispatch("SpaceStore/enableOrDisabledSpaceAction", {
        spaceId: selectedSpaceCustomize.id,
        payload: {
          enabled: !selectedSpaceCustomize.enabled,
        },
        callback: (space) => {
          this.loadingEnabled = false;
          this.confirmDisabled = false;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.spaceUpdate")
          );
          if (space.id == selectedSpaceCustomize.id) {
            this.$store.dispatch("SpaceStore/setSpaceAction", space);
            this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", space);
          } else {
            this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", space);
          }
        },
      });
  }
  async activeGamekiller() {
    if (!this.activeOptionPlan(PLAN.GAMES)) return;
    const selectedSpaceCustomize = this.selectedSpaceCustomize;
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("GameKillerStore/activeGameKillerAction", {
      spaceId: selectedSpaceCustomize.id,
      callback: async (response) => {
        if (space.id == selectedSpaceCustomize.id) {
          space.isAssassinGameActivated = true;
          this.$store.dispatch("SpaceStore/setSpaceAction", space);
          this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", space);
        } else {
          selectedSpaceCustomize.isAssassinGameActivated = true;
          this.$store.dispatch(
            "SpaceStore/setSpaceAction",
            selectedSpaceCustomize
          );
        }
      },
      callbackError: (error) => {
        console.log("TTT KO", error);
      },
    });
  }
  async disableGamekiller() {
    const selectedSpaceCustomize = this.selectedSpaceCustomize;
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("GameKillerStore/disableGameKillerAction", {
      spaceId: selectedSpaceCustomize.id,
      callback: async (response) => {
        if (space.id == selectedSpaceCustomize.id) {
          space.isAssassinGameActivated = false;
          this.$store.dispatch("SpaceStore/setSpaceAction", space);
          this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", space);
        } else {
          selectedSpaceCustomize.isAssassinGameActivated = false;
          this.$store.dispatch(
            "SpaceStore/setSpaceAction",
            selectedSpaceCustomize
          );
        }
      },
      callbackError: (error) => {
        console.log("TTT KO", error);
      },
    });
  }
}
